import { render, staticRenderFns } from "./group_info.vue?vue&type=template&id=8d94052c&scoped=true&"
import script from "./group_info.vue?vue&type=script&lang=js&"
export * from "./group_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d94052c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d94052c')) {
      api.createRecord('8d94052c', component.options)
    } else {
      api.reload('8d94052c', component.options)
    }
    module.hot.accept("./group_info.vue?vue&type=template&id=8d94052c&scoped=true&", function () {
      api.rerender('8d94052c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/groups/tabs/group_info.vue"
export default component.exports